import { Text } from "@totalenergiescode/mobility-business-rev-design-system";
import {
  Suffix,
  translateChoice,
  translateField,
  useFormDataContext,
} from "@totalenergiescode/mobility-business-rev-form-data/components";
import { DataType } from "@totalenergiescode/mobility-business-rev-form-data/lib";

import { StyledSummaryContainerDiv, StyledSummaryLabelText } from "./styles";

interface DefaultSummaryDecoratorProps {
  fallback?: string;
  fieldId: string;
}

function DefaultSummaryDecorator({
  fieldId,
  fallback,
}: Readonly<DefaultSummaryDecoratorProps>) {
  const { decoratorStore, findFieldById, form, translator, translatorFor } =
    useFormDataContext();

  const field = findFieldById(fieldId);

  const isSelectionDecorator =
    decoratorStore.typeFor(field.decorator) === DataType.SELECTION;

  const fieldTranslator = isSelectionDecorator
    ? translatorFor(field)
    : translator;
  const label = translateField(fieldTranslator, field, Suffix.LABEL);

  let value = form.submit().findSubmittedValueByFieldId(field.id());

  if (isSelectionDecorator) {
    const choice = field.value.asChoice();
    value = choice.hasBeenSet()
      ? `${translateChoice(fieldTranslator, field, choice.mustSelection(), Suffix.LABEL)}`
      : (fallback ?? translator.translate("noSelection"));
  }

  return (
    <StyledSummaryContainerDiv>
      <StyledSummaryLabelText variant='text2'>
        {label.toString()}
      </StyledSummaryLabelText>
      <Text variant='text2' fontWeight='medium'>
        {value ?? fallback ?? translator.translate("nothing")}
      </Text>
    </StyledSummaryContainerDiv>
  );
}

export default DefaultSummaryDecorator;
